import BttfAxios from "@features/utils/axios";
import axios, { AxiosResponse } from "axios";

class TermsAndConditionsAnnouncementsClass {
  public create(data: {
    ids: number[],
    return_url: string | null;
  }): Promise<AxiosResponse<{ url: string }>> {
    return BttfAxios.post(
      `api/terms_and_conditions_announcements/accept`,
      data,
      (res) => {
        return Promise.resolve(res);
      },
      (err) => {
        return Promise.reject(err);
      }
    );
  }

  public get(): Promise<AxiosResponse<unknown>> {
    return axios.get(
      "/terms_and_conditions",
      {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      }
    );
  }
}
const TermsAndConditionsAnnouncementsService =
  new TermsAndConditionsAnnouncementsClass();

export default TermsAndConditionsAnnouncementsService;
